import { render, staticRenderFns } from "./BannerPerfomance.vue?vue&type=template&id=81f0b1d6&"
import script from "./BannerPerfomance.vue?vue&type=script&lang=js&"
export * from "./BannerPerfomance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports